import { flushSync } from 'react-dom';
import { useState, useMemo } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

/**
 * https://github.com/streamich/react-use/blob/master/src/useMeasure.ts
 *
 * Copy of useMeasure from react-use with a fix for React18 "automatic batching"
 * See https://github.com/streamich/react-use/issues/2522
 *
 */
const isBrowser = typeof window !== 'undefined';
const noop = () => {
  /** */
};
const defaultState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function useMeasure() {
  const [element, ref] = useState(null);
  const [rect, setRect] = useState(defaultState);
  const observer = useMemo(() => new window.ResizeObserver(entries => {
    if (entries[0]) {
      const {
        x,
        y,
        width,
        height,
        top,
        left,
        bottom,
        right
      } = entries[0].contentRect;
      flushSync(() => {
        setRect({
          x,
          y,
          width,
          height,
          top,
          left,
          bottom,
          right
        });
      });
    }
  }), []);
  useIsomorphicLayoutEffect(() => {
    if (!element) return;
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [element]);
  return [ref, rect];
}
var useMeasure$1 = isBrowser && typeof window.ResizeObserver !== 'undefined' ? useMeasure : () => [noop, defaultState];

export { useMeasure$1 as default };
//# sourceMappingURL=useMeasure.js.map
